<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>代付</h1>
        <p></p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.api.route.hangmuxitong.com</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://api.yunfastpay.com</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
          <div><span class="font-weight-bold">说明：</span><span style="color:red">为了资金安全，建议代付配置服务器ip白名单，配置后只能由白名单的ip发起代付</span></div>
          <div>dome请见AgentTrans，<router-link tag="a" :to="{path:'/interface/zysm'}">下载deom</router-link>
          </div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>TRANS0108</td></tr>
          <tr><td>组织机构代码</td><td>orgCd</td><td>String（15）</td><td>是</td><td></td></tr>
          <tr><td>商户号</td><td>mchtCd</td><td>String（20）</td><td>是</td><td></td></tr>
          <tr><td>外部订单号</td><td>outOrderId</td><td>String（32）</td><td>是</td><td>下游上送的交易流水号</td></tr>
          <tr><td>产品编号</td><td>proCd</td><td>String(15)</td><td>是</td><td>代付：agent</td></tr>
          <tr><td>费率通道</td><td>chanelType</td><td>String(32)</td><td>是</td><td>默认：1</td></tr>
          <tr><td>账户类型</td><td>acctType</td><td>String(1)</td><td>是</td><td>1：对私,2：对公</td></tr>
          <tr><td>是否默认审核</td><td>checkStatus</td><td>String(150)</td><td>是</td><td>1:自动审核，目前固定1</td></tr>
          <tr><td>交易金额</td><td>transAmt</td><td>String（16）</td><td>是</td><td></td></tr>
          <tr><td>收款卡号</td><td>settleAcct</td><td>String(48)</td><td>是</td><td></td></tr>
          <tr><td>收款户名</td><td>settleAcctNm</td><td>String(150)</td><td>是</td><td></td></tr>
          <tr><td>异步通知地址</td><td>notifyUrl</td><td>String(255)</td><td>是</td><td></td></tr>
          <tr><td>收款支行号</td><td>settleBankNo</td><td>String(48)</td><td>否</td><td></td></tr>
          <tr><td>收款支行名</td><td>settleBankNm</td><td>String(150)</td><td>否</td><td></td></tr>
          <tr><td>代付用途类型</td><td>adddata1</td><td>String(60)</td><td>否</td><td>汇聚必填：工资资金 201，活动经费 202，养老金 203，货款 204，劳务费 205，保险理财 206，资金下发207，营业退款208，其他209，退回款项210，消费款项211</td></tr>
          <tr><td>交易描述</td><td>outOrderDesc</td><td>String(512)</td><td>否</td><td></td></tr>
          <tr><td>是否通道复核</td><td>isCheck</td><td>String(1)</td><td>否</td><td>1:复核，0：不复核，默认0；传复核需要通道后台复核才能出款(仅汇聚通道支持)</td></tr>
          <tr><td>身份证</td><td>licenceNo</td><td>String（20）</td><td>否</td><td>hqy,ckh通道必填</td></tr>
          <tr><td>手机号</td><td>commTel</td><td>String（20）</td><td>否</td><td>银行卡预留手机号，ckh通道必填</td></tr>
          <tr><td>任务编号</td><td>adddata2</td><td>String（20）</td><td>否</td><td>ckh通道必填</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（12）</td><td>是</td><td>成功：0000 失败：非0000，具体失败查看描述
          </td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（512）</td><td>是</td><td>对应应答码信息描述，包含中文</td></tr>
          <tr><td>交易状态</td><td>transStatus</td><td>String（10）</td><td>否</td><td>100-支付成功（支付订单）或退款成功（退款订单）
            101-待支付
            102-支付失败（支付订单）或退款失败（退款订单）
            103-订单处理中
            104-已撤销
          </td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'Qb',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [
        {'url': '/interface/base/tjbmd', 'name': '添加白名单'},
        {'url': '/interface/base/bmdcx', 'name': '白名单查询'},
        {'url': '/interface/fz', 'name': '分账'},
        {'url': '/interface/cx', 'name': '交易查询'},
        {'url': '/interface/shyecx', 'name': '商户余额查询'},
        {'url': '/interface/qb', 'name': '钱包代付'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/Qb.vue